/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useController} from 'react-hook-form'

import {ROUTES} from '#/lib/routes/constants.ts'
import {type SignUpFormData} from '#/lib/schemas/sign-up'
import {Button, ButtonText} from '#/components/Button'
import LockIcon from '#/components/icons/LockIcon'
import {AccentLink} from '#/wsocial/components/primitives'
import {useSemanticTokens} from '#/wsocial/service/design-system'
import {ErrorMsg, LogoBlock, PageShell} from './primitives'
import {inputRowStyle, inputStyle} from './styles'
import {type SignUpForm} from './types'

export function StepInvite({
  form,
  onNext,
  error = '',
}: {
  form: SignUpForm
  onNext: () => void
  error?: string
}) {
  const tokens = useSemanticTokens()
  const {field} = useController<SignUpFormData, 'inviteCode'>({
    control: form.control,
    name: 'inviteCode',
  })

  return (
    <PageShell>
      <LogoBlock />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          padding: '0 16px',
        }}>
        <h1
          style={{
            fontSize: 30,
            fontWeight: 700,
            lineHeight: '35px',
            color: '#fff',
            margin: 0,
          }}>
          Invitation code required
        </h1>
        <p
          style={{
            fontSize: 13,
            fontWeight: 400,
            lineHeight: '17px',
            color: tokens.onboarding.textLow,
            margin: 0,
          }}>
          If you don't have an account or haven't received an invitation, please{' '}
          <AccentLink href={ROUTES.SIGNUP}>join the waitlist</AccentLink>.
        </p>
      </div>

      <div
        style={{
          padding: '24px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}>
        <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
          <div style={inputRowStyle(tokens)}>
            <LockIcon />
            <input
              type="text"
              placeholder="Enter invitation code"
              value={field.value}
              onChange={e => field.onChange(e.target.value)}
              onBlur={field.onBlur}
              onKeyDown={e => e.key === 'Enter' && field.value && onNext()}
              className="SignInInput"
              style={inputStyle}
              autoComplete="off"
              autoFocus
              data-testid="inviteCodeInput"
            />
          </div>
          <ErrorMsg msg={error} />
        </div>
      </div>

      <div
        style={{
          padding: '16px 16px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}>
        <Button
          label="Continue"
          color="primary"
          size="large"
          testID="inviteNextBtn"
          onPress={onNext}
          disabled={!field.value.trim()}>
          <ButtonText>Continue</ButtonText>
        </Button>
      </div>
    </PageShell>
  )
}
